export const portableTextComponents = {
    block: {
        normal: ({ children }) => <p className="mb-1">{children}</p>,
        h1: ({ children }) => <h1 className="mb-3">{children}</h1>,
        h2: ({ children }) => <h2 className="mb-3">{children}</h2>,
        h3: ({ children }) => <h3 className="mb-2">{children}</h3>,
        h4: ({ children }) => <h4 className="mb-2">{children}</h4>,
        blockquote: ({ children }) => <blockquote className="mb-3 pl-4 border-l-4 border-gray-300">{children}</blockquote>,
    },
    marks: {
        strong: ({ children }) => <strong>{children}</strong>,
        em: ({ children }) => <em>{children}</em>,
        link: ({ value, children }) => {
            const target = (value?.href || '').startsWith('http') ? '_blank' : undefined
            return (
                <a
                    href={value?.href}
                    target={target}
                    rel={target === '_blank' ? 'noopener noreferrer' : undefined}
                >
                    {children}
                </a>
            )
        },
    },
}; 